import React from "react";

const InvalidPaymentLink = () => {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8">
                    <div className="card border-0 shadow-sm rounded-4 p-4 text-center">
                        <div className="card-body">
                            {/* Error Icon */}
                            <div className="mb-4">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="80"
                                    height="80"
                                    fill="#dc3545"
                                    className="bi bi-exclamation-circle"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                </svg>
                            </div>

                            {/* Error Message */}
                            <h3 className="fw-bold text-danger mb-3">
                                Invalid Payment Link
                            </h3>

                            <p className="text-muted mb-4">
                                The payment link you are trying to access is invalid or has expired.
                                <br />
                                Please contact support for a new payment link.
                            </p>

                            {/* Contact Info */}
                            <div className="bg-light p-3 rounded-3 mb-4">
                                <p className="mb-2 fw-semibold">Need Help?</p>
                                <p className="mb-0 text-muted small">
                                    Please reach out to our support team for assistance.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvalidPaymentLink;
